<template>
  <div class="interactive-map-widget">
    <Carousel
      :value="carouselItems"
      :num-visible="1"
      :num-scroll="1"
      :circular="true"
      :autoplay-interval="6000"
    >
      <template #item="slotProps">
        <div class="carousel-item">
          <template v-if="slotProps.data.type === 'weather'">
            <div class="weather-container">
              <div class="weather-content">
                <img :src="slotProps.data.icon" alt="Weather Icon" />
                <span class="weather-text-condition text-middle">{{
                  slotProps.data.condition
                }}</span>
                <span class="weather-text">Temperatura: {{ slotProps.data.temperature }}ºC</span>
              </div>
              <div class="weather-content">
                <span class="weather-text">Chuva: {{ slotProps.data.precipitation }}%</span>
                <span class="weather-text text-middle"
                  >Umidade: {{ slotProps.data.humidity }}%</span
                >
                <span class="weather-text">Vento: {{ slotProps.data.wind }}</span>
              </div>
            </div>
          </template>
          <!-- <template
            v-if="slotProps.data.type === 'alert' && slotProps.data.description.alert.length > 0"
          >
            <h3>Alertas de Clima</h3>
            <p>{{ slotProps.data.description.alert }}</p>
          </template> -->
          <template v-if="slotProps.data.type === 'exchange'">
            <div
              :key="data.flag"
              v-for="data in slotProps.data.description"
              class="exchange-container"
            >
              <img :src="data.flag" :alt="data.base" />
              <div class="exchange-header">
                <span class="exchange-text-name">{{ data.name }}</span>
                <span class="exchange-text-rates">R$ {{ data.rates.toFixed(2) }}</span>
              </div>
            </div>
          </template>
        </div>
      </template>
    </Carousel>
  </div>
</template>

<script>
import Carousel from 'primevue/carousel'
import axios from 'axios'

export default {
  components: {
    Carousel,
  },
  data() {
    return {
      currentWeatherData: null,
      alertsWeatherData: null,
      exchangeData: null,
      carouselItems: [],
    }
  },
  mounted() {
    this.getCurrentWeather()
    // this.getAlertsWeather()
    this.getExchange()
  },
  methods: {
    async getCurrentWeather() {
      try {
        const response = await axios.get('/api/weather/current')
        this.currentWeatherData = response.data
        this.updateCarouselItems()
      } catch (error) {
        console.error(error)
      }
    },
    async getAlertsWeather() {
      try {
        const response = await axios.get('/api/weather/alerts')
        this.alertsWeatherData = response.data
        console.log('this.alertsWeatherData')
        console.log(this.alertsWeatherData)
        this.updateCarouselItems()
      } catch (error) {
        console.error(error)
      }
    },
    async getExchange() {
      try {
        const response = await axios.get('/api/exchange/latest')
        this.exchangeData = response.data
        this.updateCarouselItems()
      } catch (error) {
        console.error(error)
      }
    },
    updateCarouselItems() {
      this.carouselItems = []

      if (this.currentWeatherData) {
        this.carouselItems.push({
          type: 'weather',
          icon: `https:${this.currentWeatherData.current.condition.icon}`,
          condition: this.currentWeatherData.current.condition.text,
          temperature: this.currentWeatherData.current.temp_c,
          precipitation: this.currentWeatherData.current.precip_mm,
          humidity: this.currentWeatherData.current.humidity,
          wind: `${this.currentWeatherData.current.wind_kph} km/h`,
        })
      }

      // if (this.alertsWeatherData) {
      //   this.carouselItems.push({
      //     type: 'alert',
      //     description: this.alertsWeatherData,
      //   })
      // }

      if (this.exchangeData) {
        this.carouselItems.push({
          type: 'exchange',
          description: this.exchangeData,
        })
      }
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
